import { computeHarvestAndArrival } from "@/lib/delivery/schedule";
import {
  formatShortDate,
  formatWeekdayShort,
} from "@/lib/delivery/format";

export function HarvestArrivalRow({
  harvestCycleDays,
  harvestedLabel,
  arrivesLabel,
  variant = "card",
  now,
}: {
  harvestCycleDays: number;
  harvestedLabel: string;
  arrivesLabel: string;
  variant?: "card" | "detail";
  now: Date;
}) {
  const { harvestDate, arrivalDate } = computeHarvestAndArrival(
    now,
    harvestCycleDays,
  );
  const harvestedText = formatShortDate(harvestDate);
  const arrivesText = formatWeekdayShort(arrivalDate);

  const wrapperClass =
    variant === "detail"
      ? "text-sm text-zinc-700"
      : "text-[11px] leading-tight text-zinc-500";

  if (variant === "detail") {
    return (
      <p
        data-testid="harvest-arrival-row"
        data-harvest={harvestDate.toISOString()}
        data-arrival={arrivalDate.toISOString()}
        data-harvest-cycle-days={harvestCycleDays}
        className={wrapperClass}
      >
        {harvestedLabel} {harvestedText} · {arrivesLabel} {arrivesText}
      </p>
    );
  }

  return (
    <p
      data-testid="harvest-arrival-row"
      data-harvest={harvestDate.toISOString()}
      data-arrival={arrivalDate.toISOString()}
      data-harvest-cycle-days={harvestCycleDays}
      className={wrapperClass}
    >
      <span className="hidden sm:inline">
        {harvestedLabel} {harvestedText} ·{" "}
      </span>
      <span>
        {arrivesLabel} {arrivesText}
      </span>
    </p>
  );
}
